module.exports = __webpack_public_path__ + "static/media/blog-single.4a8c8329.jpg";